import React from 'react';
import { Chip } from '@mui/material';

interface PriorityChipProps {
  priority: string;
  size?: 'small' | 'medium';
}

export const PriorityChip: React.FC<PriorityChipProps> = ({ priority, size = 'small' }) => {
  let color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' = 'default';
  
  switch(priority?.toLowerCase()) {
    case 'high':
      color = 'error';
      break;
    case 'medium':
      color = 'warning';
      break;
    case 'low':
      color = 'info';
      break;
  }
  
  return <Chip label={priority} color={color} size={size} />;
};
